import { collection, addDoc, getDocs, query, where } from 'firebase/firestore';
import { Collections, getCollection } from './collections';
import { handleFirebaseError } from './errors';
import type { JobApplication, FirebaseJobApplication } from '../../types/applications';

export async function submitJobApplication(application: Omit<FirebaseJobApplication, 'id'>) {
  try {
    const applicationsCollection = collection(
      getCollection(Collections.JOBS), 
      application.jobId, 
      'applications'
    );

    const docRef = await addDoc(applicationsCollection, {
      ...application,
      createdAt: new Date().toISOString(),
      status: application.status || 'pending'
    });

    return { id: docRef.id, error: null };
  } catch (error) {
    return { id: null, error: handleFirebaseError(error) };
  }
}

export async function getJobApplications(jobId: string) {
  try {
    const applicationsCollection = collection(
      getCollection(Collections.JOBS), 
      jobId, 
      'applications'
    );
    
    const snapshot = await getDocs(applicationsCollection);
    const applications = snapshot.docs.map(doc => ({
      id: doc.id,
      ...doc.data()
    })) as FirebaseJobApplication[];

    return { applications, error: null };
  } catch (error) {
    return { applications: [], error: handleFirebaseError(error) };
  }
}

export async function getUserApplications(userId: string) {
  try {
    const jobsCollection = getCollection(Collections.JOBS);
    const jobs = await getDocs(jobsCollection);

    const applications: JobApplication[] = [];

    for (const jobDoc of jobs.docs) {
      const applicationsCollection = collection(jobDoc.ref, 'applications');
      const q = query(applicationsCollection, where('farmhandId', '==', userId));
      const snapshot = await getDocs(q);
      
      applications.push(
        ...snapshot.docs.map(doc => ({
          id: doc.id,
          jobId: jobDoc.id,
          ...doc.data()
        })) as JobApplication[]
      );
    }

    return { applications, error: null };
  } catch (error) {
    return { applications: [], error: handleFirebaseError(error) };
  }
}